import { Box, Flex } from '../../Core';
import { Table, Tbody, Td, Tr } from '../../Table';
import type { ChartTooltipProps } from './ChartTooltip';
import { ChartTooltipValue } from './ChartTooltipValue';
import { ChartTooltipWrapper } from './styles';
import type { ChartTooltipValueType } from './types';
import { getChartSeriesColor } from './utils';

type BubbleChartTooltipProps = {
  xLabel: string;
  yLabel: string;
  zLabel: string;
  xValueType: ChartTooltipValueType;
  yValueType: ChartTooltipValueType;
  zValueType: ChartTooltipValueType;
} & Omit<ChartTooltipProps, 'shared' | 'valueType'>;

export function BubbleChartTooltip({
  data,
  title,
  xLabel,
  yLabel,
  zLabel,
  xValueType,
  yValueType,
  zValueType,
  homeCurrency,
}: BubbleChartTooltipProps) {
  if (data) {
    return (
      <ChartTooltipWrapper>
        <Box color="colorTextImportant" fontSize="fontSizeDefault" mb="spacing8">
          {title ?? data.series.name}
        </Box>
        <Flex gap="spacing4">
          <Box background={getChartSeriesColor(data)} w="0.25rem" borderRadius="0.125rem" />
          <Table>
            <Tbody>
              <Tr>
                <Td>{xLabel}</Td>
                <Td align="right">
                  <ChartTooltipValue data={data.point.x} valueType={xValueType} currency={homeCurrency} />
                </Td>
              </Tr>
              <Tr>
                <Td>{yLabel}</Td>
                <Td align="right">
                  <ChartTooltipValue data={data.point.y} valueType={yValueType} currency={homeCurrency} />
                </Td>
              </Tr>
              <Tr>
                <Td>{zLabel}</Td>
                <Td align="right">
                  <ChartTooltipValue data={data.point.z} valueType={zValueType} currency={homeCurrency} />
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </Flex>
      </ChartTooltipWrapper>
    );
  }
  return <></>;
}
